var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"medium-editor-container"},[_c('div',{ref:"content",staticClass:"editor read-only has-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }